<template>
    <div>
        <a href="#" class="fa fa-upload" title="Загрузить из Shapefile (ZIP), KML, KMZ" @click.stop="selectFile"></a>
        <input type="file" name="shapefile" ref="shapefile" @change="uploadFile" accept="application/zip,.kml,.kmz">
    </div>
</template>

<script>
    import Vue from 'vue'
    import Resource from 'vue-resource'

    Vue.use(Resource);

    export default Vue.extend({
        mounted() {
            this.$refs.shapefile.onclick = e => e.stopPropagation();
        },

        methods: {
            selectFile: function () {
                this.$refs.shapefile.value = null;
                this.$refs.shapefile.click();
            },

            uploadFile: function (event) {
                let file = event.target.files[0];

                if (file) {
                    let shapeFileUpload = new FormData();
                    shapeFileUpload.append('shapefile', event.target.files[0]);

                    this.$emit('loading');

                    return this.$http
                        .post('/map/export/upload-shape', shapeFileUpload)
                        .then(
                            response => this.$emit('complete', response.body),
                            error => this.$emit('failed', error.body)
                        );
                }
            }
        }
    });
</script>

<style scoped>
    input {
        display: none;
    }

    a, label {
        cursor: pointer;
    }

    label {
        display: block;
    }
</style>


// WEBPACK FOOTER //
// ShapeFileUploader.vue?64a69166